import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { AuthService, User } from '@icullen/api/shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'icullen-account-warning',
  templateUrl: './account-warning.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./account-warning.component.scss'],
})
export class AccountWarningComponent implements OnInit {
  user: User = this.authService.getCurrentUser();

  constructor(
    private authService: AuthService,
    private ref: ChangeDetectorRef
  ) {
    this.setDaysBeforeSubscriptionExpires();
    authService.authenticationEventObservable.subscribe(() => {
      this.user = authService.getCurrentUser();
      this.setDaysBeforeSubscriptionExpires();
      this.ref.detectChanges();
    });
  }

  ngOnInit(): void {}

  setDaysBeforeSubscriptionExpires() {
    if (
      this.user?.accountWarningType === 'SUBSCRIPTION_INCOMPLETE_TIMER' &&
      this.user?.expirationDate
    ) {
      const MS_PER_DAY: number = 1000 * 60 * 60 * 24;
      const start: number = new Date().getTime();
      const end: number = this.user.expirationDate;
      this.user.daysBeforeSubscriptionExpires = Math.ceil(
        (end - start) / MS_PER_DAY
      );
      if (this.user.daysBeforeSubscriptionExpires < 0) {
        this.user.daysBeforeSubscriptionExpires = 0;
      }
    }
  }

  ngOnDestroy(): void {}
}
